import React, {useEffect, useMemo, useState} from 'react';
import {Avatar, Badge, Button, Dropdown, List, Menu, Typography} from 'antd';
import {CheckOutlined, MailOutlined, WarningOutlined,} from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';
import {useDispatch, useSelector} from 'react-redux';
import {getAllUnreadNotifications, getUnreadNotifications, setAsRead,} from 'redux/actions';
import {ALERT, MESSAGE, SUCCESS} from 'constants/NotificationsConstants';
import {useHistory} from 'react-router-dom';
import HelperService from 'services/HelperService';
import NotificationIcon from 'components/icons/Notification';

const { Text } = Typography;

const Icon = ({ type }) => {
  switch (type) {
    case ALERT:
      return (
        <Avatar className={`ant-avatar-danger`} icon={<WarningOutlined />} />
      );
    case MESSAGE:
      return <Avatar className={`ant-avatar-info`} icon={<MailOutlined />} />;
    case SUCCESS:
      return (
        <Avatar className={`ant-avatar-success`} icon={<CheckOutlined />} />
      );
    default:
      return <Avatar className={`ant-avatar-info`} icon={<MailOutlined />} />;
  }
};

const NotificationBody = ({ list, onItemClick }) => {
  return list && list.length > 0 ? (
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={list}
      renderItem={(item) => (
        <List.Item className="list-clickable" onClick={() => onItemClick(item)}>
          <Flex alignItems="center" className="overflow-hidden">
            <div className="pr-3">
              <Icon type={item.notification_type} />
            </div>
            <div className="mr-3 d-flex flex-column overflow-hidden">
              <span className="font-weight-bold text-dark">{item.title} </span>
              <Text className="text-gray-light" ellipsis={true}>
                {item.short_description}
              </Text>
            </div>
            <small className="ml-auto" style={{ whiteSpace: 'nowrap' }}>
              {HelperService.date(item.created_at)}
            </small>
          </Flex>
        </List.Item>
      )}
    />
  ) : (
    <div className="empty-notification">
      <img
        src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg"
        alt="empty"
      />
      <p className="mt-3">You have viewed all notifications</p>
    </div>
  );
};

export const NavNotification = () => {
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const { unreadNotifications, unreadCount } = useSelector(
    (s) => s.notifications
  );
  const history = useHistory();

  const lastUnreadNotifications = useMemo(() => {
    if (unreadNotifications && unreadNotifications?.length > 5) {
      return unreadNotifications.slice(0, 5);
    } else {
      return unreadNotifications;
    }
  }, [unreadNotifications]);

  useEffect(() => {
    dispatch(getAllUnreadNotifications());
    dispatch(getUnreadNotifications());
  }, [dispatch]);

  const handleVisibleChange = (flag) => {
    setVisible(flag);
  };

  const handleViewAll = () => {
    setVisible(false);
    history.push('/app/inbox');
  };

  const handleOnListItemClick = (notification) => {
    setVisible(false);
    dispatch(setAsRead(notification));
    history.push(`/app/inbox/${notification.id}`);
  };

  const notificationList = (
    <div className="nav-dropdown nav-notification">
      <div className="nav-notification-header d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Notification</h4>
      </div>
      <div className="nav-notification-body">
        <NotificationBody
          list={lastUnreadNotifications}
          onItemClick={handleOnListItemClick}
        />
      </div>
      {lastUnreadNotifications && lastUnreadNotifications.length > 0 ? (
        <div className="nav-notification-footer p-0">
          <Button type="link" size="small" block onClick={handleViewAll}>
            View all
          </Button>
        </div>
      ) : null}
    </div>
  );

  return (
    <Dropdown
      placement="bottomRight"
      overlay={notificationList}
      onVisibleChange={handleVisibleChange}
      visible={visible}
      trigger={['click']}
    >
      <Menu mode="horizontal walkthrough-custom-notifications">
        <Menu.Item className="d-flex align-items-center justify-content-center h-100">
          <Badge count={unreadCount}>
            <NotificationIcon className="nav-icon mx-auto" type="bell" />
          </Badge>
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default NavNotification;
